import React from "react";
import FunnelDataBlock from "./block";
import { roleTypeColors } from "../../../constants/statistics";
import { FunnelDisplayData } from "../../../types";
import { EventCounts } from "../../../services";
import { generateNewPieData } from "../roundDiagrm";
import {
  pieTestData,
  pieTestDataSplitPractice,
} from "../../../constants/events";
import PieChart from "../charts/pieDiagram";

const FunnelDiagram = (props: FunnelDisplayData) => {
  // Находим максимальное значение в массиве values;
  const { config, values } = props;
  const { template, combinePractice } = config;
  const maxCount = Math.max(...values.map((item) => item.value));

  // Функция для расчета ближайшего большего круглого значения
  const calculateCountLimit = (maxValue: number) => {
    if (maxValue === 0) return 0; // Если максимальное значение 0, возвращаем 0

    const order = Math.pow(10, Math.floor(Math.log10(maxValue))); // Определяем порядок числа
    const rounded = Math.ceil(maxValue / order) * order; // Округляем до ближайшего большего круглого значения

    return rounded;
  };

  const countLimit = calculateCountLimit(maxCount);

  if (template === "round") {
    /* 
    export interface EventCounts {
    eventsByType: {
        type_id: number;
        count: number;
    }[];
    totalCount: number;
    }
    */
    let totalCount = 0;
    const counts: EventCounts = {
      eventsByType: values.map((item, index) => {
        totalCount += Number(item.value);
        return {
          type_id: item.type_id,
          count: item.value,
        };
      }),
      totalCount,
    };
    const displayData = generateNewPieData(
      combinePractice ? pieTestData : pieTestDataSplitPractice,
      counts
    );
    return (
      <div className="funnel w100">
        <div className="inner w100 flex gap24">
          <div className="inner gridCenter w100">
            <PieChart data={displayData} size={480} />
          </div>
        </div>
      </div>
    );
  }

  if (template === "column") {
    return (
      <div className="funnel w100">
        <div className="inner w100 flex gap24" style={{ height: 400 }}>
          <div className="columnCenter between h100" style={{ width: 20 }}>
            <div className="funnelItemText">{countLimit}</div>
            <div className="funnelItemText">{(countLimit / 2) * 3}</div>
            <div className="funnelItemText">{countLimit / 2}</div>
            <div className="funnelItemText">{countLimit / 4}</div>
            <div
              className="funnelItemText"
              style={{
                marginRight: 8 * countLimit.toString().length,
              }}
            >
              {0}
            </div>
          </div>
          <div
            className="h100 flex"
            style={{ width: "calc(100% - 140px)", alignItems: "flex-end" }}
          >
            {values.map((value, index) => {
              return (
                <FunnelDataBlock
                  key={`fblock${index}`}
                  color={roleTypeColors[index % roleTypeColors.length]}
                  heading={value.heading}
                  template={template}
                  count={value.value}
                  conversion={
                    Math.round((value.value * 10000) / maxCount) / 100
                  }
                  maxCount={countLimit}
                />
              );
            })}
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="funnel w100">
      <div className={`inner w100 columnCenter`}>
        <div className="w100 columnCenter">
          {values.map((value, index) => {
            return (
              <FunnelDataBlock
                key={`fblock${index}`}
                color={roleTypeColors[index % roleTypeColors.length]}
                heading={value.heading}
                template={template}
                count={value.value}
                conversion={Math.round((value.value * 10000) / maxCount) / 100}
                maxCount={countLimit}
              />
            );
          })}
        </div>
        <div className="flex between w100">
          <div className="funnelItemText">{countLimit}</div>
          <div className="funnelItemText">{countLimit / 2}</div>
          <div className="funnelItemText">{0}</div>
          <div className="funnelItemText">{countLimit / 2}</div>
          <div
            className="funnelItemText"
            style={{
              marginRight: 8 * countLimit.toString().length,
            }}
          >
            {countLimit}
          </div>
        </div>
      </div>
    </div>
  );
};

export default FunnelDiagram;
